import React from "react";
import styles from "./UsersSkeleton.module.scss";

const UsersSkeleton: React.FC = () => {
  return (
    <div className="container mt-4">
      <h1 className={styles.skeletonHeader}></h1>
      <div className={styles.searchSkeleton}></div>

      <div className={styles.userList}>
        {[...Array(10)].map((_, index) => (
          <div key={index} className={styles.userCard}>
            <div className={styles.cardHeader}></div>
            <div className={styles.cardBody}></div>
          </div>
        ))}
      </div>

      <div className={styles.paginationSkeleton}></div>
    </div>
  );
};

export default UsersSkeleton;
